/**
 * Created by Sushma Muppala in 2023
 */

import React, { memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import ComplicationSelector from "@ls/grouping-complication-selector";
import SelectionState from "state/selections/SelectionState";
import Scan2SelectorComplication from "./Scan2SelectorComplication";
import Scan2Definition from "state/scan2/Scan2Definition";
import { selectDefinitions } from "state/scan2/selectors";
import { setDefinition as setScan2Definition } from "state/scan2/actions";

const Scan2Selector = () => {
  const dispatch = useDispatch();
  const definitions = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  );
  const setDefinition = useCallback(
    (definitions, idx) => dispatch(setScan2Definition(definitions, idx)),
    [dispatch]
  );

  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinition}
      getDefaultDefinition={Scan2Definition.getDefault}
      ComplicationComponent={Scan2SelectorComplication}
      btnTitle={"VaR"}
      addMoreText={"VaR (% Return)"}
    />
  );
};

export default memo(Scan2Selector);
